import { requestHandler } from '../../../api';

export const getAllRoles = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/admin/roles`,
    dispatch,
  });
  if (response) return response.data;
};

export const createNewRole = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/admin/roles`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const assignRoleToUser = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/admin/users/${data.id}/assginRole`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getAllPermissions = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/admin/allPermissions`,
    dispatch,
  });
  if (response) return response.data;
};

export const assignPermissionsToRole = async (
  dispatch: any,
  data: { id: number; permissions: string[] },
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/admin/roles/${data.id}/assignPermissions`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
